import { makeStyles, Theme } from '@material-ui/core';

export const useLayoutStyles = makeStyles((theme: Theme) => ({
    container: {
        backgroundColor: theme.palette.info.light,
        justifyItems: 'space-between',
    },
}));
